import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GgFirmwareVerificationAdapter } from './gg-firmware-verification.adapter';
import { GGFirmwareWSDTO } from '../../components/gg-firmware-verification/gg-firmware-verification.component';

@Injectable()
export class GgFirmwareVerificationConnector {
  constructor(private productFirmwareVerificationAdapter: GgFirmwareVerificationAdapter) {}

  checkFirmware(extraID: string): Observable<GGFirmwareWSDTO[]> {
    return this.productFirmwareVerificationAdapter.checkFirmware(extraID);
  }
}
